'use client'

import { ErrorDataUnavailable } from '@/components/common/Error'

const VaultV2AllocationTransactionsError = () => {
  return (
    <div data-testid="vault-v2-allocation-transactions-error">
      <ErrorDataUnavailable minHeight="378px" />
    </div>
  )
}

export default VaultV2AllocationTransactionsError
